class PrintBulkCashController {
    /*@ngInject*/
    constructor($translate, $scope) {
        this.$translate = $translate;
        this.$scope = $scope;
    }

    $onInit() {
        const checkData = setInterval(() => {
            if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.ready) {
                clearInterval(checkData);
                const data = window.opener.w.printData;
                this.denomBalance = data.denomBalance;
                this.bulkCashHistorys = data.bulkCashHistorys;
                this.currencySymbol = data.currencySymbol;
                this.branchName = data.branchName;
                this.locationName = data.locationName;
                this.dateRange = data.dateRange;
                this.searchText = data.searchText;
                this.curBalance = data.curBalance;
                this.accountType = data.accountType;

                if (this.$scope) {
                    this.$scope.$applyAsync();
                }

                setTimeout(() => {
                    window.print();
                }, 1000);
            }
        }, 100);
    }

    isManualAdjustment(bulkCashDetails) {
        if (!bulkCashDetails.mainEntry) return;

        if (!bulkCashDetails.comment || bulkCashDetails.mainEntry.change >= 0) return;

        const adjustmentList = ['Undo pack of:', 'Order pack tracking:', 'Creating emergency deposit for', 'Creating deposit for', 'Editing residual:', 'Coin Shipment Checkout'];
        const len = adjustmentList.length;

        for (let i = 0; i < len; i++) {
            const regex = new RegExp(adjustmentList[i], 'i');
            if (bulkCashDetails.comment.match(regex)) return false;
        }
        return true;
    }
}

export default PrintBulkCashController;



// WEBPACK FOOTER //
// ./client/app/components/bulk_cash_management/print/print_bulk_cash.controller.js